/**
 * Client-only：app 開機 / 重整時，若 cookie 還原出 token，主動 schedule 下次 renew。
 *
 * 為什麼要這個 plugin：
 * - auth store 的 `scheduleRenew` 只在 `login()` 時被呼叫。
 * - 重整 / 新 tab 開時，token 從 cookie 還原進 store，但沒 login 流程觸發 schedule。
 * - 若不補這道，重整後 proactive renewal 失效，只剩 401 reactive fallback。
 *
 * 用 `.client.ts` 後綴限定只在 client 跑：setTimeout 不適合 SSR。
 */
export default defineNuxtPlugin({
  name: 'auth-init',
  dependsOn: ['pinia'],
  setup() {
    try {
      const auth = useAuthStore()
      if (auth.token) {
        auth.scheduleRenew()
      }
    }
    catch {
      // Pinia 早期 race — 忽略；下次 login / interaction 會再排
    }
  },
})
